import type { RefObject } from 'react';
import { useLayoutEffect } from 'react';

import { useSetClipped } from './use-set-clipped.ts';

export const useContentClipping = ({
    ref,
    partial,
}: {
    ref: RefObject<HTMLDivElement | null>;
    partial: boolean | undefined;
}): void => {
    const setClipped = useSetClipped();

    useLayoutEffect(() => {
        const panel = ref.current;

        if (!partial || !panel) return;

        const measure = () => {
            if (!panel.matches('[data-closed]')) return;

            setClipped(panel.scrollHeight > panel.clientHeight);
        };

        measure();

        const observer = new ResizeObserver(measure);

        observer.observe(panel);

        return () => {
            observer.disconnect();
        };
    }, [ref, partial, setClipped]);
};
